import { reactive, toRefs } from "vue";

const state = reactive({
  dialogVisible: false,
  title: "",
  message: "",
  confirmLabel: "Ok",
  cancelLabel: "Cancel",
  warnings: [] as Record<string, string>[],
  resolve: (value: boolean) => {},
  reject: () => {},
});

export type ConfirmDialogOptions = {
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  warnings?: Record<string, string>[];
};

export function useConfirmationDialog() {
  async function show(options: ConfirmDialogOptions): Promise<boolean> {
    state.title = options.title ?? "Confirm";
    state.message = options.message ?? "Are you sure?";
    state.confirmLabel = options.confirmLabel ?? "Ok";
    state.cancelLabel = options.cancelLabel ?? "Cancel";
    state.warnings = options.warnings ?? [];

    state.dialogVisible = true;

    return new Promise((resolve, reject) => {
      state.resolve = resolve;
      state.reject = reject;
    });
  }

  const confirm = () => {
    if (state.resolve) {
      state.resolve(true);
    }
    state.dialogVisible = false;
  };

  const cancel = () => {
    if (state.resolve) {
      state.resolve(false); // Resolve with false for cancellation
    }
    state.dialogVisible = false;
  };

  return {
    ...toRefs(state),
    show,
    confirm,
    cancel,
  };
}
